import Vue from 'vue'

let formMixin = {
  components: { Vue },

  data: function () {
    return {
      currentLanguage: 'en',
      config: {}
    }
  },

  beforeMount () {
    this.config = Object.assign(this.config, Vue.config)
  },

  methods: {
    _saveData () {

    },
    _prepareData () {
      if (this.object) {
        for (let f in this.object) {

        }
      }
    }
  }

}

export default formMixin
